import React, { Fragment } from 'react';
import Panel from '../../../../components/outline/Panel';
import TableWithSummary from '../../../../components/table/TableWithSummary';
import { EVENT_LIST_TABLE_EMPTY_TEXT } from '../../../../constants/service/app/eventConstants';
import { EVENT_LIST_FILTER_OPTION_MODEL } from '../../../../store/modules/event/models';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import columns from './columns';
import Button from '../../../../components/Button';

const EventAllList = (props) => {
  const {
    allEventList,
    originalAllEventList,
    isUpdateList,
    getList,
    getExcelDownload,
    openEventItemListModal,
    setInitialAllEventList,
    getEventTagColumnTagList,
  } = props;
  const { list, filterOption, pagination, summary } = allEventList;

  return (
    <div className="event-all-list">
      <Panel>
        {
          /**
           *  전체 기획전 리스트가 변경이 있을 때만 초기화, 저장 버튼을 노출한다
           */
          isUpdateList ? (
            <div className="panel-header">
              <div className="btn-area">
                <Fragment>
                  <Button isRadius text="초기화" onClick={() => setInitialAllEventList()} />
                </Fragment>
              </div>
            </div>
          ) : null
        }

        <div className="panel-body">
          <TableWithSummary
            data={list}
            totalCnt={summary.totalCnt}
            initialOption={{
              filterOption: EVENT_LIST_FILTER_OPTION_MODEL,
              pagination: LIST_PAGINATION_MODEL,
            }}
            emptyText={EVENT_LIST_TABLE_EMPTY_TEXT}
            showPagination
            filterOption={filterOption}
            pagination={pagination}
            getList={getList}
            getExcelDownload={getExcelDownload}
            getTdProps={(state, rowInfo) => {
              const currentStatus = rowInfo?.original?.status;
              const originalStatus = originalAllEventList?.[rowInfo?.index]?.status;

              return {
                className: currentStatus && originalStatus && currentStatus !== originalStatus ? 'isChange' : null,
              };
            }}
            columns={(utils) =>
              columns({
                openEventItemListModal,
                getEventTagColumnTagList,
                ...utils,
              })
            }
          />
        </div>
      </Panel>
    </div>
  );
};

export default EventAllList;
